import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)

export class DateUtil {
  static formatDate(d: string, format: string): string {
    return dayjs(d).format(format)
  }

  static formatShort(d: string): string {
    return this.formatDate(d, 'DD/MM/YYYY')
  }

  static formatMedium(d: string): string {
    return this.formatDate(d, 'DD/MM/YYYY HH:mm')
  }

  static formatFull(d: string): string {
    return this.formatDate(d, 'DD/MM/YYYY HH:mm:ss')
  }
}
